import { IResponseState } from "../../../../components/Modals/ResponseModal/module/constants";

import {
  STATE_IDENTIFIER,
  LIST_IDENTIFIER,
  LOADER_IDENTIFIER,
} from "./constants";

const {
  STEP_ONE,
  STEP_TWO,
  TEMPLATE_MAIL_TABLE,
  TEMPLATE_MAIL_DETAIL,
  REQUEST_STATE,
} = STATE_IDENTIFIER;

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  [STEP_ONE]: {
    [TEMPLATE_MAIL_TABLE]: {
      [LIST_IDENTIFIER]: [],
      [LOADER_IDENTIFIER]: false,
    },
  },
  [STEP_TWO]: {
    [TEMPLATE_MAIL_DETAIL]: {
      [LIST_IDENTIFIER]: [],
      [LOADER_IDENTIFIER]: false,
    },
  },
  [REQUEST_STATE]: IResponseState.PENDING,
};
